import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const { settings } = useSite();
  return (
    <footer className="relative border-t border-[#1A1A1A] bg-[#080808]" data-testid="main-footer">
      <div className="hairline-gold absolute inset-x-0 top-0" />
      <div className="mx-auto max-w-7xl px-6 py-14 lg:py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <img src="/assets/iem-emblem.png" alt="IEM" className="h-14 w-14 rounded-full ring-1 ring-gold/25" />
              <div>
                <div className="font-serif text-2xl tracking-[0.15em] text-[#F5F3EE]">IEM</div>
                <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-gold">Iconic Elite Management S.R.L.S.</div>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#969696]">
              Agenzia di digital management d'élite specializzata nello sviluppo di brand iconici e nella
              scalabilità del business per Content Creator.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] tracking-[0.3em] uppercase text-gold font-semibold">Navigazione</div>
            <ul className="mt-5 space-y-3 text-sm text-[#969696]">
              <li><Link data-testid="footer-creator-link" to="/creator" className="transition-colors hover:text-gold">Creator</Link></li>
              <li><Link data-testid="footer-lavora-link" to="/lavora-con-noi" className="transition-colors hover:text-gold">Lavora con noi</Link></li>
              <li><Link data-testid="footer-metodo-link" to="/metodo-privacy" className="transition-colors hover:text-gold">Metodo & Privacy</Link></li>
              <li><Link data-testid="footer-chi-siamo-link" to="/chi-siamo" className="transition-colors hover:text-gold">Chi siamo</Link></li>
              <li><Link data-testid="footer-partnership-link" to="/partnership-dopamine" className="transition-colors hover:text-gold">Partnership</Link></li>
              <li><Link data-testid="footer-faq-link" to="/faq" className="transition-colors hover:text-gold">FAQ</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-gold font-semibold">Contatto diretto</div>
            <div className="mt-5">
              <a
                data-testid="footer-whatsapp-link"
                href={settings.whatsapp_url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-3 border border-[#1A1A1A] bg-[#111111] px-5 py-4 transition-colors duration-300 hover:border-gold/50"
              >
                <MessageCircle size={18} className="text-gold" />
                <span>
                  <span className="block text-sm text-[#F5F3EE]">WhatsApp</span>
                  <span className="mt-0.5 block text-xs tracking-wide text-[#969696]">+39 328 711 6258</span>
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 border-t border-[#1A1A1A] pt-8">
          <div
            className="grid gap-6 text-xs leading-relaxed text-[#969696] sm:grid-cols-2 lg:grid-cols-4"
            data-testid="footer-legal-data"
          >
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#F5F3EE]">
                Iconic Elite Management S.r.l.s.
              </p>
              <p className="mt-2">
                P.IVA e C.F.: 06305130871
                <br />
                R.E.A.: CT - 488773 (CCIAA di Catania)
                <br />
                Capitale Sociale: € 2.000,00 i.v.
              </p>
            </div>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#F5F3EE]">Sede Legale</p>
              <p className="mt-2">Via Martino Cilestri 71<br />95127 Catania (CT), Italia</p>
            </div>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#F5F3EE]">Contatti PEC</p>
              <p className="mt-2">
                <a href="mailto:iconic_elite@pec.it" data-testid="footer-pec-link" className="transition-colors hover:text-gold">
                  iconic_elite@pec.it
                </a>
              </p>
            </div>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#F5F3EE]">Email</p>
              <p className="mt-2">
                <a href="mailto:1pietrolicandro@gmail.com" data-testid="footer-email-link" className="transition-colors hover:text-gold">
                  1pietrolicandro@gmail.com
                </a>
              </p>
            </div>
          </div>
          <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-[#1A1A1A] pt-8 sm:flex-row sm:items-center">
            <p className="text-xs text-[#969696]">
              © 2026 Iconic Elite Management S.r.l.s. — P.IVA 06305130871. Tutti i diritti riservati.
            </p>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
              <Link
                data-testid="footer-privacy-link"
                to="/privacy-policy"
                className="text-xs tracking-[0.2em] uppercase text-[#969696] transition-colors hover:text-gold"
              >
                Privacy Policy
              </Link>
              <Link
                data-testid="footer-cookie-link"
                to="/cookie-policy"
                className="text-xs tracking-[0.2em] uppercase text-[#969696] transition-colors hover:text-gold"
              >
                Cookie Policy
              </Link>
              <Link
                data-testid="footer-admin-link"
                to="/admin"
                className="text-xs tracking-[0.2em] uppercase text-[#969696] transition-colors hover:text-gold"
              >
                Area Riservata
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
